<template>
  <v-card-text>
    <div class="table-container">
      <table class="my-table">
        <thead>
          <tr>
            <th v-for="(header, index) in headers" :key="index" @click="handleHeaderClick(header.value)" style="cursor:pointer">
                <v-icon v-if="header.icon">{{header.icon}}</v-icon>
                <br v-if="header.icon"/>
                <span v-if="index>=col_hide"> {{ header.text }}</span>
            </th>
          </tr>
        </thead>
        <!-- Render data rows -->
        <tbody>
          <tr v-for="(rowdata, rowIndex) in items" :key="rowIndex">
            <td v-for="(celldata, colIndex) in rowdata" :key="colIndex" @click="handleCellClick(row, cell, rowIndex, colIndex)" style="cursor:pointer; text-align: center">
              <span v-if="colIndex >=col_hide">{{ celldata }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-card-text>
  </template>

<script>

export default {
    data() {
        return {
            typeRes: 0,
        }
    },
    props: {
        items: Array,
        col_hide: Number, // how many columns hide, first is id

        col_link: Number, // how many columns at begin link to row address eg. name + surname
        row_address: String, // where to link from first columns, 
        row_address_parameter_name: String, // first parameter name

        headers: Array, // headers strings with ids
        header_address: String, // address for link after click to header
        header_address_parameter_name: String, // first parameter name
        header_parameters_list: Object,

        cell_address: String, // address for link after click to cell - values are id and header_ids
        cell_address_parameter_row: String, // first parameter name
        cell_address_parameter_column: String, // second parameter name
    },
    methods: {
      handleHeaderClick(_id) {
        // console.log(this.header_address)
        const _par = this.header_parameters_list
        _par[this.header_address_parameter_name] = _id
        this.$router.push({name: this.header_address, params: _par})
      },
      handleCellClick(_row, _cell, _rowIndex, _colIndex) {

      }

    }

}

</script>

<style>
  .table-container {
    width: 100%; /* Šírka kontajnera, v ktorom bude tabuľka */ 
    overflow-y: auto; /* Horizontálne posúvanie, ak je obsah širší než kontajner */
    display: block;
  }

  .my-table th,
  .my-table td {
    padding: 4px; /* Pridajte požadovanú hodnotu odsadenia pre medzery */
  }
</style>